import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_RATING_CLEAR: "AUDIT_RATING_CLEAR",

    AUDIT_RATINGS_CORE_GET_FAILURE: "AUDIT_RATINGS_CORE_GET_FAILURE",
    AUDIT_RATINGS_CORE_GET_REQUEST: "AUDIT_RATINGS_CORE_GET_REQUEST",
    AUDIT_RATINGS_CORE_GET_SUCCESS: "AUDIT_RATINGS_CORE_GET_SUCCESS",

    AUDIT_RATING_GET_FAILURE: "AUDIT_RATING_GET_FAILURE",
    AUDIT_RATING_GET_REQUEST: "AUDIT_RATING_GET_REQUEST",
    AUDIT_RATING_GET_SUCCESS: "AUDIT_RATING_GET_SUCCESS",

    AUDIT_RATING_ITEM_CLEAR: "AUDIT_RATING_ITEM_CLEAR",
    AUDIT_RATING_ITEM_SET: "AUDIT_RATING_ITEM_SET"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDIT_RATING_CLEAR
    }),

    getCoreRequest: () => ({
        type: actionTypes.AUDIT_RATINGS_CORE_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_RATINGS_CORE_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_RATINGS_CORE_GET_FAILURE
    }),
    getCoreSuccess: (auditRating) => ({
        type: actionTypes.AUDIT_RATINGS_CORE_GET_SUCCESS,
        payload: { auditRating }
    }),
    getCoreFailure: (error: Error) => ({
        type: actionTypes.AUDIT_RATINGS_CORE_GET_FAILURE,
        error
    }),

    getRequest: () => ({
        type: actionTypes.AUDIT_RATING_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_RATING_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_RATING_GET_FAILURE
    }),
    getSuccess: (auditRating) => ({
        type: actionTypes.AUDIT_RATING_GET_SUCCESS,
        payload: { auditRating }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.AUDIT_RATING_GET_FAILURE,
        error
    }),

    itemClear: () => ({
        type: actionTypes.AUDIT_RATING_ITEM_CLEAR
    }),
    itemSet: (auditRating: any) => ({
        type: actionTypes.AUDIT_RATING_ITEM_SET,
        payload: { auditRating }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
